export const FETCH_PEAK = 'FETCH_PEAK';
export const FETCH_MEANF = 'FETCH_MEANF';
export const FETCH_SEEING = 'FETCH_SEEING';


/* use the state type FETCH_PEAK FETCH_MEANF FETCH_SEEING */
